<form [formGroup]="form" (ngSubmit)="submit()">
  <h2 mat-dialog-title id="student-post-title">Create Post</h2>

  <mat-dialog-content class="dialog-content">
    <quill-editor
      class="editor"
      formControlName="content"
      theme="snow"
      placeholder="What do you want to share?"
      [modules]="quillConfig"
      (onEditorCreated)="onEditorCreated($event)"
      (onContentChanged)="onContentChanged($event)"
      data-testid="student-post-editor"
    >
    </quill-editor>

    <p
      class="char-count"
      [class.over-limit]="textLength() > maxLength"
      aria-live="polite"
      data-testid="student-post-char-count"
    >
      {{ textLength() }} / {{ maxLength }}
    </p>

    @if (careers.length || interests.length) {
      <div class="tag-group">
        <h3 class="tag-group__title">
          Tags <span class="tag-group__hint">Optional — helps the right people find your post</span>
        </h3>
        <div class="tag-group__fields">
          @if (careers.length) {
            <mat-form-field appearance="outline">
              <mat-label>Careers</mat-label>
              <mat-select formControlName="careers" multiple data-testid="student-post-careers">
                @for (c of careers; track c.id) {
                  <mat-option [value]="c.id">{{ c.name }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          }
          @if (interests.length) {
            <mat-form-field appearance="outline">
              <mat-label>Interests</mat-label>
              <mat-select formControlName="interests" multiple data-testid="student-post-interests">
                @for (i of interests; track i.id) {
                  <mat-option [value]="i.id">{{ i.name }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          }
        </div>
      </div>
    }
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button mat-dialog-close type="button" data-testid="student-post-cancel-btn">
      Cancel
    </button>
    <button
      mat-flat-button
      type="submit"
      [disabled]="!canSubmit"
      data-testid="student-post-submit-btn"
    >
      {{ isSubmitting() ? 'Posting…' : 'Post' }}
    </button>
  </mat-dialog-actions>
</form>
